import React, { useCallback, useEffect, useRef, useState, useMemo } from "react";
import Grid from "@material-ui/core/Grid";
import { useStyles } from "./Header.styles";
import { AppBar, Avatar, Badge, Collapse, Drawer, IconButton, Link, List, ListItem, ListItemIcon, ListItemText, SvgIcon, Toolbar, Typography } from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import { Link as RouterLink, useHistory, withRouter } from "react-router-dom";
import { ReactComponent as usersNavLogoIcon } from "./../../assets/icons/users-icon.svg";
import { ReactComponent as usersDriverLogoIcon } from "./../../assets/icons/users-three-icon.svg";
import { ReactComponent as hubsIcon } from "./../../assets/icons/hubs-icon.svg";
import { ReactComponent as downArrowIcon } from "./../../assets/icons/down-arrow-icon.svg";
import { ReactComponent as rightArrowIcon } from "./../../assets/icons/right-arrow-icon.svg";
import { ReactComponent as allOrdersIcon } from "./../../assets/icons/all-orders-icon.svg";
import { ReactComponent as DotsThreeOutlineIcon } from "./../../assets/icons/DotsThreeOutline.svg";
import { ReactComponent as bellIcon } from "./../../assets/icons/bell-icon.svg";
import PersonIcon from "@material-ui/icons/Person";
import { useDispatch, useSelector } from "react-redux";
import { userLogout } from "../../Login/redux/loginSlice";
import AppConstants from "../../constants";
import SelectBox, { SelectItemProps } from "../SelectBox";
import SearchableMultipleDropdown from "../SearchableMultipleDropdown/index";
import {
  countryCodeUpdate,
  fetchCountryConfigDetils,
  fetchCountryHubDetailsDetils,
  fetchCwingsReportCountriesList,
  hubCodeUpdate,
} from "../../config/redux/common/commonSlice";
import { fetchNotificationCount } from "../../NotificationCenter/redux/notificationCenterSlice";
import { resetPlanningData } from "../../RoutePlanning/redux/planningSlice";
import { AppState } from "../../config/redux/reducers";
import { isEqualArrays, isNull, isUndefined, isFeatureEnabledForCountry } from "../../utils/helpers.utils";
import { ReactComponent as stdDeliveryIcon } from "./../../assets/icons/standard-delivery-icon.svg";
import { ReactComponent as offlineDeliveryIcon } from "./../../assets/icons/offline-delivery-icon.svg";
import { ReactComponent as reportIcon } from "./../../assets/icons/chart-line-up.svg";
import { ReactComponent as opsDashboardIcon } from "./../../assets/icons/dashboard-icon-bars.svg";
import { ReactComponent as delveGroupIcon } from "./../../assets/icons/delve-icon.svg";
import { ReactComponent as expressDeliveryIcon } from "./../../assets/icons/bike.svg";
import { ReactComponent as dwnloadAppIcon } from "./../../assets/icons/download-app.svg";
import { customerCommunicationFeatureEnabledForCountries } from "../../config/Api.config";
import NotificationCenterDialog from "NotificationCenter";
import { NotificationCenterConst } from "../../constants/NotificationConstant";
import { TextConstants } from "constants/TextConstants";
import FeaturesContants from "constants/FeaturesContants";
import UACConstants, { UAC_ROUTE_MAP, UAC_ICON_MAP } from "../../constants/UACConstants";

interface MenuStructure {
  key: string;
  name: string;
  route: string;
  submenus: MenuStructure[];
}

const UAC_FEATURE_MAP: { [key: string]: string } = {
  [UACConstants.DM_LOCATIONS]: FeaturesContants.DRIVER_LOCATION_DASHBOARD,
  // Add more mappings as needed for other features
};

const UAC_COUNTRY_FEATURE_MAP: { [key: string]: string } = {
  COMMUNICATIONS: customerCommunicationFeatureEnabledForCountries,
  // Add more mappings as needed for other country-specific features
};

const Header = (props: any) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();

  const initialRender = useRef(true); // Track the first render

  const { 
    countryCode, 
    cwingsReportCountriesList, 
    hubRecordList, 
    hubRecordListWithCodeAndName,
    userFeatureConfigDetails,
    hubCodeResetTrigger
  } = useSelector((state: AppState) => state.common);
   
  const {
    uacData: reduxUacData,
  } = useSelector((state: AppState) => state.userLogin);

  const { notificationCount } = useSelector((state: AppState) => state.notificationCenter);
  const [notificationsCount, setNotificationsCount] = useState(0);
  const { location, openSideMenuOnClick, handleDrawerOnClick } = props;
  const [openDrawer, setOpenDrawer] = useState(false);
  const [afterUpdate, setAfterUpdate] = useState(false);
  const [openHeaders, setOpenHeaders] = useState<string[]>([]);
  const [selectedNav, setSelectedNav] = useState(false);
  const [tabValue, setTabValue] = useState(location.pathname.substr(1));
  const [selectedHeadergroup, setSelectedHeadergroup] = useState("");
  const [country, setCountry] = useState(sessionStorage.getItem(AppConstants.COUNTRY_CODE) || countryCode || AppConstants.COUNTRY_OBJ.value);
  const [hub, setHub] = useState(JSON.parse(sessionStorage.getItem(AppConstants.HUB_CODE) || "[]"));
  const [title, setTitle] = useState("");
  const [headerState, setHeaderState] = useState<{ activeStatus: boolean }>({ activeStatus: true });
  const [imageUrl, setImageUrl] = useState<string | null>(null);
  const [openNotificationDialog, setOpenNotificationDialog] = useState(false);

  // Fetch notification count on mount and at regular intervals
  useEffect(() => {
    const fetchNotifications = () => {
      dispatch(fetchNotificationCount({ filters: { ...NotificationCenterConst.DEFAULT_FILTERS_COUNT, countryCode: country } }));
    };

    fetchNotifications();
    const intervalId = setInterval(fetchNotifications, NotificationCenterConst.FETCH_INTERVAL);

    return () => clearInterval(intervalId);
  }, [dispatch, country]);

  // Fetch notification count on mount and at regular intervals
  useEffect(() => {
      setNotificationsCount(notificationCount);
  } , [notificationCount]);

  const handleDrawerOpen = () => {
    setOpenDrawer(true);
  };

  const handleDrawerClose = () => {
    setOpenHeaders([]);
    setOpenDrawer(false);
  };

  const toggleDrawer = useCallback(() => {
    handleDrawerOnClick(!openDrawer);
    openDrawer ? handleDrawerClose() : handleDrawerOpen();
  }, [openDrawer, handleDrawerOnClick]);

  const handleUserLogout = useCallback(() => {
    dispatch(userLogout());
  }, [dispatch]);

  const handleCountryChange = (value: string) => {
    setCountry(value);
    dispatch(countryCodeUpdate({ countryCode: value }));
    dispatch(resetPlanningData());
  };

  const handleHubChange = useCallback((value: any) => {
    setHub(value);
  }, []);

  const getActiveRoute = useCallback(
    (routes: any[]) => {
      return routes.findIndex((item: any) => (item.hasParams ? `/${tabValue}`.indexOf(item.route) > -1 : item.route === `/${tabValue}`)) > -1;
    },
    [tabValue]
  );

  const handleDrawerHover = useCallback(() => {
    if (openSideMenuOnClick) {
      return;
    }
    handleDrawerOpen();
  }, [openSideMenuOnClick]);

  const handleDrawerHoverExit = useCallback(() => {
    if (openSideMenuOnClick) {
      return;
    }
    handleDrawerClose();
  }, [openSideMenuOnClick]);

  const getCurrentRole = () => {
    let role = "";
    const currentRoles = sessionStorage.getItem("role");
    if (currentRoles) {
      const currentRole = JSON.parse(currentRoles)[0];
      if (currentRole) {
        role = currentRole.value;
      }
    }
    return role;
  };

  // Build menu structure from UAC data with permission check and feature filtering
  const menuStructure = useMemo(() => {
    if (!reduxUacData?.uac) return [];

    const menus = reduxUacData.uac.filter((item: any) => item.type === "MENU");
    
    return menus
      .map((menu: any) => {
        const submenus = reduxUacData.uac.filter(
          (item: any) => item.type === "SUBMENU" && item.parentKey === menu.key
        );
        
        // Filter submenus based on feature configuration
        const filteredSubmenus = submenus
          .filter((submenu: any) => {
            // Check if feature is enabled in user's feature config
            const featureKey = UAC_FEATURE_MAP[submenu.key];
            const hasFeatureAccess = !featureKey || userFeatureConfigDetails?.includes(featureKey);
            
            // Check if feature is enabled for country
            const countryFeatures = UAC_COUNTRY_FEATURE_MAP[submenu.key];
            const hasCountryAccess = !countryFeatures || isFeatureEnabledForCountry(countryFeatures, country);
            
            return hasFeatureAccess && hasCountryAccess;
          })
          .map((submenu: any) => ({
            ...submenu,
            route: UAC_ROUTE_MAP[submenu.key] || "#",
            hasEditPermission: Array.isArray(submenu.permissions) && submenu.permissions.includes("EDIT"),
            hasViewPermission: Array.isArray(submenu.permissions) && (submenu.permissions.includes("VIEW") || submenu.permissions.includes("EDIT"))
          }));
        
        return {
          ...menu,
          submenus: filteredSubmenus,
          route: filteredSubmenus.length > 0 ? UAC_ROUTE_MAP[filteredSubmenus[0].key] || "#" : UAC_ROUTE_MAP[menu.key] || "#"
        };
      })
      .filter((menu: any) => {
        // Check if menu itself has a feature requirement
        const menuFeatureKey = UAC_FEATURE_MAP[menu.key];
        const menuHasFeature = !menuFeatureKey || userFeatureConfigDetails?.includes(menuFeatureKey);
        
        // Check if menu has country-specific requirements
        const menuCountryFeatures = UAC_COUNTRY_FEATURE_MAP[menu.key];
        const menuHasCountryAccess = !menuCountryFeatures || isFeatureEnabledForCountry(menuCountryFeatures, country);
        
        // Show menu if it has feature access AND country access AND (has visible submenus OR is a standalone menu)
        return menuHasFeature && menuHasCountryAccess && (menu.submenus.length > 0 || !reduxUacData.uac.some((item: any) => item.type === "SUBMENU" && item.parentKey === menu.key));
      });
  }, [reduxUacData, userFeatureConfigDetails, country]);

    // Find which parent menu contains the current route
    const getActiveParentMenu = useCallback(() => {
      const currentPath = `/${tabValue}`;
      
      for (const menu of menuStructure) {
        if (menu.submenus && menu.submenus.length > 0) {
          const isActiveSubmenu = menu.submenus.some((submenu: any) => 
            submenu.route === currentPath || currentPath.startsWith(submenu.route)
          );
          if (isActiveSubmenu) {
            return menu.key;
          }
        } else if (menu.route === currentPath) {
          return menu.key;
        }
      }
      return null;
    }, [menuStructure, tabValue]);
  
    // Update openHeaders when drawer opens to show active parent's submenu
    useEffect(() => {
      if (openDrawer) {
        const activeParent = getActiveParentMenu();
        if (activeParent && !openHeaders.includes(activeParent)) {
          setOpenHeaders([activeParent]);
        }
      }
    }, [openDrawer, getActiveParentMenu]);

  // Get default landing route
  const defaultRoute = useMemo(() => {
    if (!reduxUacData?.uac) return AppConstants.ROUTES.PLANNING;
    
    const defaultMenu = reduxUacData.uac.find((item: any) => item.key === reduxUacData.defaultMenu);
    if (!defaultMenu) return AppConstants.ROUTES.PLANNING;
    
    if (defaultMenu.type === "MENU") {
      const firstSubmenu = reduxUacData.uac.find(
        (item: any) => item.type === "SUBMENU" && item.parentKey === defaultMenu.key
      );
      return firstSubmenu ? UAC_ROUTE_MAP[firstSubmenu.key] : UAC_ROUTE_MAP[defaultMenu.key];
    }
    
    return UAC_ROUTE_MAP[defaultMenu.key] || AppConstants.ROUTES.PLANNING;
  }, [reduxUacData]);

  // Redirect to default route on mount if needed
  useEffect(() => {
    if (location.pathname === "/" && defaultRoute) {
      history.push(defaultRoute);
    }
  }, [defaultRoute, location.pathname, history]);

  // Get icon component by key
  const getIconComponent = (iconKey: string) => {
    const iconMap: { [key: string]: any } = {
      stdDeliveryIcon,
      expressDeliveryIcon,
      offlineDeliveryIcon,
      DotsThreeOutlineIcon,
      allOrdersIcon,
      hubsIcon,
      usersNavLogoIcon,
      delveGroupIcon,
      usersDriverLogoIcon,
      reportIcon,
      dwnloadAppIcon,
      opsDashboardIcon,
    };
    return iconMap[UAC_ICON_MAP[iconKey]] || hubsIcon;
  };

  // Render dynamic menu items
  const renderMenuItem = (menu: any) => {
    const hasSubmenus = menu.submenus && menu.submenus.length > 0;
    const IconComponent = getIconComponent(menu.key);

    if (!hasSubmenus) {
      return (
        <ListItem
          key={menu.key}
          className="listItem"
          button
          component={RouterLink}
          to={menu.route}
          selected={getActiveRoute([{ route: menu.route }])}
        >
          <ListItemIcon className="itemIcon">
            <SvgIcon className="listIcon" viewBox="0 0 26 24" component={IconComponent} />
          </ListItemIcon>
          <ListItemText primary={menu.name} />
        </ListItem>
      );
    }

    const isOpen = checkOpenHeader(menu.key);

    return (
      <Grid key={menu.key}>
        <ListItem
          className="listItem"
          button
          selected={getActiveRoute(menu.submenus.map((s: any) => ({ route: s.route })))}
          onClick={() => handleHeaderClick(menu.key, menu.submenus)}
        >
          <ListItemIcon className="itemIcon">
            <SvgIcon className="listIcon" viewBox="0 0 26 24" component={IconComponent} />
          </ListItemIcon>
          <ListItemText primary={menu.name} />
          {isOpen ? (
            <SvgIcon className="dropdownIcon" component={downArrowIcon} viewBox="0 0 21 21" />
          ) : (
            <SvgIcon className="dropdownIcon" component={rightArrowIcon} viewBox="0 0 21 21" />
          )}
        </ListItem>
        <Collapse in={isOpen} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {menu.submenus.map((submenu: any) => (
              <ListItem
                key={submenu.key}
                className="listItem subItem"
                button
                component={RouterLink}
                to={submenu.route}
                selected={getActiveRoute([{ route: submenu.route }])}
              >
                <ListItemText primary={submenu.name} />
              </ListItem>
            ))}
          </List>
        </Collapse>
      </Grid>
    );
  };

  // Update handleHeaderClick to properly toggle submenus
  const handleHeaderClick = (headerId: string, submenus: any[]) => {
    const isCurrentlyOpen = openHeaders.includes(headerId);
    
    if (isCurrentlyOpen) {
      // Close this submenu
      setOpenHeaders(openHeaders.filter(id => id !== headerId));
      setSelectedNav(false);
    } else {
      // Open this submenu and close others
      setOpenHeaders([headerId]);
      setSelectedNav(true);
      
      // Navigate to first submenu if not already on one
      const currentPath = `/${tabValue}`;
      const isOnSubmenu = submenus.some((submenu: any) => 
        submenu.route === currentPath || currentPath.startsWith(submenu.route)
      );
      
      if (!isOnSubmenu && submenus.length > 0) {
        history.push(submenus[0].route);
      }
    }
  };

  // Update checkOpenHeader to work with UAC keys
  const checkOpenHeader = useCallback(
    (headerId: string) => {
      return openHeaders.includes(headerId);
    },
    [openHeaders]
  );

  // Read image data from sessionStorage on component mount
  useEffect(() => {
    const imageData = sessionStorage.getItem("images");
    if (imageData) {
      const parsedData = JSON.parse(imageData);
      setImageUrl(parsedData.md);
    }
  }, []);

  const handleNotificationDialogClose = useCallback(
    () => {
      setOpenNotificationDialog(false);
    },
    [],
  );

  const fetchUserDetails = () => {
    dispatch(fetchCwingsReportCountriesList());
    if (initialRender.current) {
      initialRender.current = false;
    } else {
      const countryCode = sessionStorage.getItem(AppConstants.COUNTRY_CODE);
      let deliveryType: string | null = null;

      if (history?.location?.pathname) {
        const pathName = history.location.pathname;
        if (pathName.includes(AppConstants.ROUTES.STANDARD)) {
          deliveryType = "STANDARD";
        } else if (pathName.includes(AppConstants.ROUTES.EXPRESS_PAGE)) {
          deliveryType = "EXPRESS";
        }
        dispatch(fetchCountryHubDetailsDetils({ countryCode, deliveryType }));
      } else {
        dispatch(fetchCountryHubDetailsDetils({ countryCode }));
      }
    }
  };

  useEffect(() => {
    if (!isNull(countryCode)) {
      fetchUserDetails();
      setAfterUpdate(true);
      dispatch(fetchCountryConfigDetils({ activeStatus: headerState.activeStatus }));
    }
  }, [countryCode]);

  useEffect(() => {
    if (hubRecordList[countryCode] && afterUpdate) {
      const sessionHubValue = JSON.parse(sessionStorage.getItem(AppConstants.HUB_CODE) || "[]");
      const ddnValues = [AppConstants.SELECT_ALL.value, ...hubRecordList[countryCode].map((hub: SelectItemProps) => hub.value)];
      if (!isEqualArrays(sessionHubValue, ddnValues)) {
        setHub(ddnValues);
      }
    }
  }, [hubRecordList]);

  useEffect(() => {
    dispatch(hubCodeUpdate(hub));
  }, [hub]);

  useEffect(() => {
    if (!hubCodeResetTrigger) return;
    // Reset unconditionally, even if the hub list for this country hasn't loaded
    // yet - gating this on `hubRecordList[countryCode]` meant the dropdown could
    // silently keep showing the old selection when that data wasn't ready at the
    // moment "Clear All Filters" was clicked. Expanding to the full hub code list
    // (when available) additionally keeps the open-dropdown's per-item checkboxes
    // in sync; the bare SELECT_ALL sentinel alone is enough for the closed chip.
    const ddnValues = hubRecordList[countryCode] ? [AppConstants.SELECT_ALL.value, ...hubRecordList[countryCode].map((hub: SelectItemProps) => hub.value)] : [AppConstants.SELECT_ALL.value];
    setHub(ddnValues);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hubCodeResetTrigger]);

  useEffect(() => {
    setTabValue(location.pathname.substr(1));
    setSelectedHeadergroup(location.pathname.split("/")[1]);
  }, [location]);

  useEffect(() => {
    if (history?.location?.pathname) {
      if (initialRender.current) {
        initialRender.current = false;
      } else {
        let deliveryType: string | null = null;
        if (history.location.pathname.includes(AppConstants.ROUTES.STANDARD)) {
          deliveryType = "STANDARD";
        } else if (history.location.pathname.includes(AppConstants.ROUTES.EXPRESS_PAGE)) {
          deliveryType = "EXPRESS";
        }
        dispatch(fetchCountryHubDetailsDetils({ countryCode, deliveryType }));
      }
      switch (history.location.pathname) {
        case AppConstants.ROUTES.VALETTROLLEY:
          setTitle("Valet Trolley");
          break;
        case AppConstants.ROUTES.PLANNING:
          setTitle("Planning");
          break;
        case AppConstants.ROUTES.TRACKING:
          setTitle("Tracking");
          break;
        case AppConstants.ROUTES.CLICKNCOLLECT:
          setTitle("Click And Collect");
          break;
        case AppConstants.ROUTES.EXPRESS:
          setTitle("Express Lebanon");
          break;
        case AppConstants.ROUTES.USERS:
          setTitle("Users");
          break;
        case AppConstants.ROUTES.CARREFOUR_HOME_DLVRY:
          setTitle("Home Delivery");
          break;
        case AppConstants.ROUTES.DELVE_DASHBOARD:
          setTitle("Delve Dashboard");
          break;
        case AppConstants.ROUTES.CARREFOUR_NOW:
          setTitle("Express Orders");
          break;
        case AppConstants.ROUTES.DRIVERS:
          setTitle("Driver Management");
          break;
        case AppConstants.ROUTES.DRIVER_LOCATIONS:
          setTitle("Locations");
          break;
        case AppConstants.ROUTES.COD_PORTAL:
          setTitle("COD Reconciliation");
          break;
        case AppConstants.ROUTES.STD_COD_PORTAL:
          setTitle("COD Reconciliation");
          break;
        case AppConstants.ROUTES.DELVE_ORDER_LIST:
          setTitle("Delve Order List");
          break;
        case AppConstants.ROUTES.ALL_ORDERS:
          setTitle("All Orders");
          break;
        case AppConstants.ROUTES.PERFORMANCE:
          setTitle("Planning Dashboard");
          break;
        case AppConstants.ROUTES.STORE_MANAGEMENT:
          setTitle("Stores");
          break;
        case AppConstants.ROUTES.APP_DOWNLOAD:
          setTitle(TextConstants.APP_DOWNLOAD);
          break;  
        default:
          setTitle("");
          break;
      }
    }
  }, [history.location.pathname]);

  const hideHubInTopMenu = (pathname: any) => {
    if (!isUndefined(pathname) && !isNull(pathname)) {
      switch (pathname) {
        case AppConstants.ROUTES.DELVE_DASHBOARD:
        case AppConstants.ROUTES.DELVE_ORDER_LIST:
        case AppConstants.ROUTES.HUBS:
        case AppConstants.ROUTES.POS:
        case AppConstants.ROUTES.COD_PORTAL:
        case AppConstants.ROUTES.STD_COD_PORTAL:
        case AppConstants.ROUTES.STAGING_AREA:
        case AppConstants.ROUTES.CUSTOMER_COMMUNICATION:
        case AppConstants.ROUTES.ALL_ORDERS:
        case AppConstants.ROUTES.RETURNS:
        case AppConstants.ROUTES.DRIVER_LOCATIONS:
          return true;
        default:
          return false;
      }
    }
    return false;
  };

  return (
    <Grid container className={classes.root}>
      <AppBar position="fixed" className={`${classes.appBar} ${openSideMenuOnClick ? "open" : "close"}`}>
        <Toolbar className="appToolbar">
          <Grid container>
            <Grid style={{ display: "flex", alignItems: "center", justifyContent: "flex-start" }}>
              <Typography className="logoSpanStyle">{`Wings`}</Typography>
              <Typography
                style={{
                  fontWeight: 600,
                  fontSize: "20px",
                  lineHeight: "24px",
                  color: "#1F1F1F",
                  padding: "0px 0px 0px 8px",
                  margin: "auto",
                }}
              >
                {title}
              </Typography>
            </Grid>
            <Grid className="countrySection" item style={{ display: "flex" }}>
              {!hideHubInTopMenu(history?.location?.pathname) && (
                <Grid>
                  <SearchableMultipleDropdown
                    id="hubCode-select-box"
                    label="Hub"
                    menuItems={hubRecordListWithCodeAndName[sessionStorage.getItem(AppConstants.COUNTRY_CODE) || countryCode] || []}
                    value={hub}
                    handleChange={handleHubChange}
                    disabled={false}
                  />
                </Grid>
              )}
              <Grid style={{ borderLeft: "1px solid #E6E6E6" }}>
                <SelectBox
                  className="countrySelect"
                  handleChange={handleCountryChange}
                  value={country}
                  menuPaperProps={classes.countryMenuPaper}
                  id="countryCode-select-box"
                  label="Country"
                  items={cwingsReportCountriesList}
                ></SelectBox>
              </Grid>
            </Grid>
            <Grid
              className="avatarSection"
              item
              style={{ borderLeft: "1px solid #E6E6E6", padding: "10px" }}
              onClick={() => {
                setOpenNotificationDialog(true);
              }}
            >
             <Grid container alignItems="center">
                <Grid className="notificationLogo" item>
                  <Badge
                    badgeContent={notificationsCount}
                    classes={{ badge: classes.badgeCount }}
                  >
                    <SvgIcon className={classes.listIcon} viewBox="0 0 26 29" component={bellIcon} />
                  </Badge>
                </Grid>
              </Grid>
            </Grid>
            <Grid className="avatarSection" item>
              <Grid container alignItems="center">
                <Grid className="avatarDetails" item>
                  <Typography className="avatarItem name">{sessionStorage.getItem("name")}</Typography>
                  <Typography className="avatarItem role">{getCurrentRole()}</Typography>
                  <Link className="avatarItem logoutBtn" onClick={handleUserLogout}>
                    Logout
                  </Link>
                </Grid>
                <Grid className="avatarLogo" item>
                  <Avatar>{imageUrl ? <img src={imageUrl} alt="Profile" style={{ width: "100%", height: "100%", borderRadius: "50%" }} /> : <PersonIcon />}</Avatar>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
      <Drawer variant="permanent" className={`${classes.drawer} ${openDrawer ? "open" : "close"}`}>
        <Grid container onMouseEnter={handleDrawerHover} onMouseLeave={handleDrawerHoverExit} className="drawerContainer">
          <Grid item className="toolbarSection">
            <Toolbar className="toolbar">
              <RouterLink className="logoSection" to={AppConstants.ROUTES.HOME}>
                <Grid container alignItems="center">
                  {openDrawer && <Typography className="logoSpanStyle">{`Wings`}</Typography>}
                </Grid>
              </RouterLink>
            </Toolbar>
          </Grid>
          <Grid className="menuBtnSection" item>
            <Grid
              container
              style={{
                paddingLeft: "12px",
              }}
            >
              <IconButton aria-label="Menu Button" onClick={toggleDrawer} edge="start">
                <MenuIcon className="menuButton" />
              </IconButton>
            </Grid>
          </Grid>
          <Grid item className="listSection">
            <List className="listContainer">
              {menuStructure.map((menu: MenuStructure) => renderMenuItem(menu))}
            </List>
          </Grid>
          <Grid item className="footerSection"></Grid>
        </Grid>
      </Drawer>
      {openNotificationDialog && (
        <NotificationCenterDialog
          openNotificationCenter={openNotificationDialog}
          handleDialogClose={handleNotificationDialogClose}
        />
      )}
    </Grid>
  );
};

export default withRouter(Header);
